import React from 'react';
import { motion } from 'framer-motion';
import { LEADERSHIP } from '../config/siteContent';

/**
 * LeadershipSection - light theme.
 * Card grid for the iConnect leadership team.
 */
const LeadershipSection = () => {
  return (
    <section id="leadership" className="relative py-24 lg:py-32 bg-bg-soft">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16 max-w-3xl mx-auto"
        >
          <p className="eyebrow">Leadership</p>
          <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl text-text-primary mb-4 tracking-[-0.02em] text-balance">
            <span className="text-gradient-sky">EDI</span>{' '}
            veterans. 25+ years deep.
          </h2>
          <p className="text-lg text-text-secondary text-pretty">
            iConnect is run by the people who built the EDI industry - former leaders from
            Harbinger, Premenos, Sterling Commerce, and Supply Tech.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {LEADERSHIP.map((person, idx) => (
            <motion.div
              key={person.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.5, delay: idx * 0.08 }}
              whileHover={{ y: -4 }}
              className="card-elevated p-6"
            >
              <div className="flex items-center gap-4 mb-4">
                {person.photo ? (
                  <img
                    src={person.photo}
                    alt={person.name}
                    loading="lazy"
                    className="w-14 h-14 rounded-full object-cover ring-2 ring-accent-primary/30 shadow-glow-sky flex-shrink-0"
                  />
                ) : (
                  <div className="w-14 h-14 rounded-full bg-gradient-sky shadow-glow-sky flex items-center justify-center text-white font-display font-bold text-base flex-shrink-0">
                    {person.initials}
                  </div>
                )}
                <div className="min-w-0">
                  <div className="font-display font-bold text-text-primary text-lg leading-tight">
                    {person.name}
                  </div>
                  <div className="text-sm text-accent-primary font-semibold">
                    {person.title}
                  </div>
                </div>
              </div>
              <p className="text-sm text-text-secondary leading-relaxed mb-3">
                {person.bio}
              </p>
              <p className="text-xs text-text-muted font-medium">{person.education}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LeadershipSection;
